import {BaseService} from './Core/BaseService';

class SpeciesListSpeciesService extends BaseService {
    get Url() { return super.Url + "/speciesListSpecies"; }

    GetSpeciesListSpeciesByList(speciesListId) {
        const request = { speciesListId: speciesListId };

        return this.SendRequest(BaseService.GET, request);
    }

    GetSpeciesListSpecies(speciesListSpeciesId) {
        return this.SendRequest(BaseService.GET, speciesListSpeciesId);
    }

    UpdateSpeciesListSpecies(speciesListSpecies) {
        return this.SendRequest(BaseService.PUT, speciesListSpecies);
    }

    CreateSpeciesListSpecies(speciesListSpecies) {
        return this.SendRequest(BaseService.POST, speciesListSpecies);
    }

    DeleteSpeciesListSpecies(speciesListSpeciesId) {
        return this.SendRequest(BaseService.DELETE, speciesListSpeciesId);
    }

    CreateDefaults(speciesListId) {
        return this.SendRequest(BaseService.POST, {speciesListId}, null, '/createDefaults');
    }
}

export const service = new SpeciesListSpeciesService();

